import React from "react";
import ModalHeading from "components/ui/Modal/ModalHeading/ModalHeading";
import CreateConversationForm from "../../form/CreateConversationForm/CreateConversationForm";
import { SideModal } from "components/ui";

const CreateConversationModal = ({
    show,
    closeModal,
    referenceData,
    modalFormAction,
    source,
}) => {
    return (
        <SideModal show={show} close={closeModal}>
            <div className='row me-0 ms-0'>
                <div className='col-10 offset-1'>
                    <ModalHeading
                        title={`Create Conversation`}
                        subTitle={`A conversation is a collection of multiple branches`}
                    />

                    <CreateConversationForm
                        referenceData={referenceData}
                        modalFormAction={modalFormAction}
                        source={source}
                    />
                </div>
            </div>
        </SideModal>
    );
};

export default CreateConversationModal;
